export const setScroll = (x = 0, y = 0) => {
  window.scrollTo(x, y)
}
